module.exports = __webpack_public_path__ + "img/00006.7c22d1c6.webp";